import React from 'react'
import styles from "./Performance.module.scss"
import Pillar from '../LowLevel/Pillar/Pillar'

export default function Performance() {
  const coreItems = [
    {
      img: "/icons/map.svg",
      title: "Understand Your Goals",
      desc: "We learn what matters most to your brand — sales, leads, growth — and map out a plan."
    },
    {
      img: "/icons/bullseye.svg",
      title: "Build Targeted Campaigns",
      desc: "We build high-impact campaigns that put your brand in front of the right people."
    },
    {
      img: "/icons/tuner.svg",
      title: "Optimize for Results",
      desc: "We test, tweak, and fine-tune performance daily to maximize results."
    },
    {
      img: "/icons/rocket.svg",
      title: "Scale Up",
      desc: "We find what works and scale it, resulting in more reach, more leads and more revenue."
    },
  ]
  return (
    <div className={styles.performanceParent} id="performance">
      <h2>The Path To Performance</h2>
      <div>
        <div className='row'>
          {coreItems.map((item, index) => (
            <div className="col-lg-3 col-md-6 col-12" key={index}>
              <Pillar item={item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
